<template>
    <v-layout row wrap>
        <v-flex lg6 md12 pr-3>
            <v-layout row wrap class="mb-4 mt-4">
                <v-btn
                    @click="startRecording"
                    :loading="loadingRecord"
                    :disabled="loadingRecord"
                    class="ml-0"
                >
                    <v-icon color="red" class="mr-2">{{ buttonRecordContent.icon }}</v-icon>
                    {{ isRecording ? $t('stopRecord') : $t('startRecord') }}
                </v-btn>
                <v-btn
                    @click="uploadFileAudioClick"
                    :loading="loadingSelectFile"
                    :disabled="loadingSelectFile"
                    class="ml-0"
                >
                    <v-icon class="mr-2" color="blue">publish</v-icon>
                    {{ $t('uploadFileAudio') }}
                </v-btn>
                <span>{{ audioFileName }}</span>
            </v-layout>
            <v-layout row wrap class="mt-5 ml-0 mr-0">
                <v-flex xl12 xs12 class="pa-0">
                    <v-textarea
                        :label="$t('textIdentified')"
                        box
                        rows="4"
                        readonly
                        disabled
                        no-resize
                        v-model="recordText"
                    ></v-textarea>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="ma-0">
                <v-flex xl12 xs12 style="box-shadow: 0 0 3px rgba(0,0,0,0.1); min-height: 130px;" class="mb-3">
                    <div id="audioRecord"></div>
                    <!--<v-btn v-if="wavesuffer" :disabled="!allowPlay" @click="playAudio"><v-icon :color="buttonPlayPauseContent.icon==='play_arrow'?'green':''" class="mr-2">{{ buttonPlayPauseContent.icon }}</v-icon>{{ buttonPlayPauseContent.text }}</v-btn>-->
                </v-flex>
                <v-flex xl12 xs12>
                    <div id="audioPlayer" class="mb-2" style="box-shadow: 0 0 3px rgba(0,0,0,0.1);"></div>
                    <v-btn v-if="wavesuffer_player" :disabled="!allowPlay" @click="playAudio" class="ml-0">
                        <v-icon :color="buttonPlayPauseContent.icon === 'play_arrow' ? 'green' : ''" class="mr-2">
                            {{buttonPlayPauseContent.icon }}
                        </v-icon>
                        {{ isPlaying ? $t('pause') : $t('play') }}
                    </v-btn>
                </v-flex>
            </v-layout>
            <input
                type="file"
                style="display: none"
                ref="uploadAudio"
                accept="audio/*"
                @change="onFilePicked"
            >
        </v-flex>
        <v-flex lg6 md12 style="text-align: left">
            <h2 class="py-2">API</h2>
            <v-select
                label="API Key"
                v-model="apiKey"
                :items="listAPIKey"
                class="mt-3"
            ></v-select>
            <v-layout row reverse wrap align-center>
                <v-btn
                    @click="$utils.copyToClipboard(code[apiType], $t('copiedToClipboard', ['code']))"
                    title="copy key to clipboard"
                    class="ma-0"
                    depressed
                    color="info"
                >
                    <v-icon>file_copy</v-icon>
                    Copy
                </v-btn>
                <v-radio-group v-model="apiType" row>
                    <v-radio label="cUrl " value="curl"></v-radio>
                    <v-radio label="Python" value="python"></v-radio>
                    <v-radio label="Php" value="php"></v-radio>
                    <v-radio label="C#" value="cSharp"></v-radio>
                </v-radio-group>
            </v-layout>
            <code>{{code[apiType]}}</code>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
/* eslint-disable */
import { inject } from '@/utils/VariableInjection'
import sttCUrl from 'raw-loader!../code/sttCUrl.txt'
import sttPython from 'raw-loader!../code/sttPython.txt'
import sttPHP from 'raw-loader!../code/sttPHP.txt'
import sttCSharp from 'raw-loader!../code/sttCSharp.txt'
import ApiDemo from '@/views/APIs/demo/ApiDemo'
/* eslint-enable */

// WaveSurfer no longer be maintained on https://npmjs.com so we need to import it as normal javascript in index.html
const WaveSurfer = window.WaveSurfer

export default {
    name: 'SpeechToTextDemo',
    extends: ApiDemo,
    props: {
        parent: Object
    },
    data () {
        return {
            wavesuffer_record: null,
            wavesuffer_player: null,
            allowPlay: false,
            isPlaying: false,
            buttonPlayPauseContent: {
                icon: 'play_arrow', // play_arrow - pause
                text: this.$t('play') // PLAY - PAUSE
            },
            buttonRecordContent: {
                icon: 'fiber_manual_record',
                text: this.$t('startRecord')
            },
            recordText: '',
            listAudioRecorder: [],
            mediaRecorder: null,
            recordingBlob: null,
            isRecording: false,
            uploadFileAudio: null,
            audioFileName: '',
            loadingSelectFile: false,
            loadingRecord: false,
            apiType: 'curl',
            file: ''
        }
    },
    computed: {
        code () {
            let variableMap = {
                url: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_SPEECH_TO_TEXT,
                apiKey: this.apiKey,
                path: this.file.name
            }
            return {
                python: inject(sttPython, variableMap),
                curl: inject(sttCUrl, variableMap),
                php: inject(sttPHP, variableMap),
                cSharp: inject(sttCSharp, variableMap)
            }
        }
    },
    async mounted () {
        await this.$nextTick(() => {
            // player
            // eslint-disable-next-line
            this.wavesuffer_player = WaveSurfer.create({
                container: '#audioPlayer',
                waveColor: '#d3d3d3',
                progressColor: '#228BB8'
            })
            this.wavesuffer_player.on('ready', () => {
                this.allowPlay = true
            })
            this.wavesuffer_player.on('finish', () => {
                this.isPlaying = false
                this.buttonPlayPauseContent.text = this.$t('play')
                this.buttonPlayPauseContent.icon = 'play_arrow'
            })
            this.$store.dispatch(this.$actionTypes.LOADING, false)
        })
    },
    methods: {
        playAudio () {
            if (this.wavesuffer_player !== null) {
                this.wavesuffer_player.playPause()
                if (this.buttonPlayPauseContent.text === this.$t('play')) {
                    this.isPlaying = true
                    this.buttonPlayPauseContent.text = this.$t('pause')
                    this.buttonPlayPauseContent.icon = 'pause'
                } else {
                    this.isPlaying = false
                    this.buttonPlayPauseContent.text = this.$t('play')
                    this.buttonPlayPauseContent.icon = 'play_arrow'
                }
            }
        },
        startRecording () {
            if (this.wavesuffer_record === null) {
                // recorder
                // var MicrophonePlugin = WaveSurfer.microphone
                let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
                let context = null
                let processor = null
                if (isSafari) {
                    let AudioContext = window.AudioContext || window.webkitAudioContext
                    context = new AudioContext()
                    processor = context.createScriptProcessor(1024, 1, 1)
                }
                this.wavesuffer_record = WaveSurfer.create({
                    container: '#audioRecord',
                    waveColor: 'blue',
                    interact: false,
                    cursorWidth: 0,
                    audioContext: context || null,
                    audioScriptProcessor: processor || null,
                    plugins: [
                        WaveSurfer.microphone.create()
                    ]
                })
                let vm = this
                this.wavesuffer_record.microphone.on('deviceReady', function (stream) {
                    vm.mediaRecorder = new MediaRecorder(stream)
                    vm.mediaRecorder.ondataavailable = event => {
                        vm.recordingBlob = event.data
                        vm.handlerRecorderBlob()
                    }
                    vm.mediaRecorder.start()
                })
                this.wavesuffer_record.microphone.on('deviceError', function (code) {
                    console.warn('Device error: ' + code)
                    vm.buttonRecordContent.icon = 'fiber_manual_record'
                    vm.buttonRecordContent.text = vm.$t('startRecord')
                    // un mark recording
                    vm.isRecording = false
                    vm.$appService.toastError(vm.$t('deviceNotFound'))
                    return false
                })
            }
            if (this.wavesuffer_record.microphone.active) {
                this.buttonRecordContent.icon = 'fiber_manual_record'
                this.buttonRecordContent.text = this.$t('startRecord')
                // un mark recording
                this.isRecording = false
                this.mediaRecorder.stop() // triggers mediaRecorder.onondataavailable
                this.wavesuffer_record.microphone.stop()
                this.mediaRecorder = null
            } else {
                // mark recording
                this.isRecording = true
                this.buttonRecordContent.icon = 'stop'
                this.buttonRecordContent.text = this.$t('stopRecord')

                this.wavesuffer_record.microphone.start()

                let vm = this
                setTimeout(() => {
                    if (vm.wavesuffer_record.microphone.active && vm.isRecording) {
                        vm.startRecording()
                    }
                }, 10000)
            }
        },
        async handlerRecorderBlob () {
            this.$refs.uploadAudio.value = ''
            this.loadingRecord = true
            let audioURL = window.URL.createObjectURL(this.recordingBlob)
            this.wavesuffer_player.load(audioURL)
            let readBlobArrayBuffer = await new Response(this.recordingBlob).arrayBuffer()
            if (this.recordingBlob.size / 1048576 > 5) {
                this.$appService.toastError(this.$t('fileMax5MB'))
                return
            }
            await axios.post(
                process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_SPEECH_TO_TEXT,
                readBlobArrayBuffer,
                {
                    headers: {
                        'api-key': this.apiKey,
                        'Content-Type': ''
                    }
                }
            ).then(response => {
                this.recordText = response.data.hypotheses[0].utterance
                if (!this.recordText) {
                    this.$appService.toastError(this.$t('canNotUnderstandSpeech'))
                }
                this.parent.getRemain()
            }).catch(error => {
                if (error.response) {
                    if (error.response.status === 429) {
                        this.$appService.toastError(this.$t('noRequestRemain'))
                    } else if (error.response.data) {
                        this.$appService.toastError(error.response.data)
                    } else {
                        this.$appService.toastError(this.$t('canNotGenerateText'))
                    }
                } else {
                    this.$appService.toastError(this.$t('canNotGenerateText'))
                }
            })
            this.loadingRecord = false
        },
        uploadFileAudioClick () {
            this.$refs.uploadAudio.click()
        },
        async onFilePicked (e) {
            let files = e.target.files
            if (files[0] !== undefined) {
                this.loadingSelectFile = true
                let supportedType = ['audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/x-wav', 'audio/x-mp3']
                if (files[0] && supportedType.indexOf(files[0].type) > -1) {
                    this.file = files[0]
                    if (this.file.size / 1048576 > 5) {
                        this.loadingSelectFile = false
                        this.$appService.toastError(this.$t('fileMax5MB'))
                        return
                    }
                    // load audio file to wavesurfer
                    let audioURL = window.URL.createObjectURL(files[0])
                    this.wavesuffer_player.load(audioURL)

                    let reader = new FileReader()
                    let vm = this
                    // let vm = this
                    reader.onload = function (ev) {
                        // The FileReader returns us the bytes from the computer's file system as an ArrayBuffer
                        let option = {
                            headers: {
                                'api-key': vm.apiKey,
                                'Content-Type': ''
                            }
                        }
                        axios.post(
                            process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_SPEECH_TO_TEXT,
                            reader.result,
                            option
                        ).then(response => {
                            vm.recordText = response.data.hypotheses[0].utterance
                            if (!vm.recordText) {
                                this.$appService.toastError(this.$t('canNotUnderstandSpeech'))
                            }
                            vm.loadingSelectFile = false
                            this.parent.getRemain()
                        }).catch(err => {
                            if (err.response && err.response.data) {
                                this.$appService.toastError(err.response.data)
                            } else {
                                this.$appService.toastError(this.$t('error'))
                            }
                            vm.loadingSelectFile = false
                        })
                    }
                    reader.readAsArrayBuffer(files[0])
                } else {
                    // show error - TODO
                    this.uploadFileAudio = null
                    this.audioFileName = ''
                }
            } else {
                this.uploadFileAudio = null
                this.audioFileName = ''
            }
        }
    }
}
</script>

<style scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    .link-container {
        background-color: #ffd8df;
        padding: 5px;
        display: flex;
        align-items: center;
    }

    code {
        padding: 5px;
        width: 100%;
    }

    code::before {
        content: "";
    }
</style>
